module.exports = __webpack_public_path__ + "img/logo-right1.404001df.png";